import { useEffect, useState } from "react";
import { Loader2, NotebookPen, Save } from "lucide-react";
import { toast } from "sonner";
import { getCoachNotes, saveCoachNotes } from "../lib/api";
import { sydDateTime } from "../lib/time";

export default function CoachNotes({ clientId }) {
  const [notes, setNotes] = useState("");
  const [savedAt, setSavedAt] = useState(null);
  const [state, setState] = useState("loading"); // loading | idle | saving | saved

  useEffect(() => {
    getCoachNotes(clientId).then((d) => { setNotes(d.notes || ""); setSavedAt(d.updated_at); setState("idle"); }).catch(() => setState("idle"));
  }, [clientId]);

  const save = async () => {
    setState("saving");
    try {
      const d = await saveCoachNotes(clientId, notes);
      setSavedAt(d.updated_at);
      setState("saved");
      toast.success("Coach Notes saved.");
      setTimeout(() => setState("idle"), 3000);
    } catch (e) {
      setState("idle");
      toast.error(e?.response?.data?.detail || "Could not save notes.");
    }
  };

  return (
    <div className="surface-card p-6 md:p-8 mt-6" data-testid="coach-notes">
      <div className="flex items-center gap-2 label-eyebrow"><NotebookPen size={14} /> Coach Notes</div>
      <p className="mt-2 text-xs text-brand-ink-muted">Private to you. Never shown to the client and never used in Weekly Insights.</p>
      <textarea
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
        disabled={state === "loading"}
        rows={5}
        placeholder="Add private notes about this client…"
        className="mt-4 w-full rounded-xl border border-brand-border bg-white px-4 py-3 text-base text-brand-ink focus:outline-none focus:ring-2 focus:ring-[#C8965A]/40 disabled:opacity-60"
        data-testid="coach-notes-textarea"
      />
      <div className="mt-3 flex items-center gap-4">
        <button type="button" onClick={save} disabled={state === "saving" || state === "loading"} className="btn-primary inline-flex items-center gap-2 disabled:opacity-60" data-testid="coach-notes-save-btn">
          {state === "saving" ? <Loader2 className="animate-spin" size={16} /> : <Save size={16} />} Save Notes
        </button>
        {state === "saved" && <span className="text-sm text-emerald-700 font-medium" data-testid="coach-notes-saved-msg">Notes saved</span>}
        {savedAt && state !== "saved" && <span className="text-xs text-brand-ink-muted" data-testid="coach-notes-updated-at">Last saved {sydDateTime(savedAt)}</span>}
      </div>
    </div>
  );
}
